import * as http from 'utils/http';
import config from 'config';

const getShippers = () => http.get(`${config.API_URL}pricing/contracted_shippers/?page_size=100`);
const getShipper = (shipperId) =>
  http.get(`${config.API_URL}pricing/contracted_shippers/${shipperId}/`);

const getContracts = (shipperId) =>
  http.get(`${config.API_URL}pricing/price_contract/?shipper_id=${shipperId}&page_size=0`);

export { getContracts, getShipper, getShippers };
